import React from 'react';
import {
  BrowserRouter as Router, Route, Switch, Redirect,
} from 'react-router-dom';

import { routes } from 'config/routes';

import Home from 'views/Home';
import Embed from 'views/Embed';
import OrderFinished from 'views/OrderFinished';
import Services from 'views/Services';

import AbsoluteRedirect from './components/AbsoluteRedirect';

const Routes = () => (
  <Switch>
    <Route exact path={[routes.tenant, routes.tenantWithP]}>
      <Redirect to="/partner/guarida" />
    </Route>
    <Route exact path={[routes.partner, routes.partnerWithP]}>
      <Redirect to="/partner/guaridaleads" />
    </Route>
    <Route exact path={[routes.home]}>
      <Home />
    </Route>
    <Route exact path={[routes.orderFinished]}>
      <OrderFinished />
    </Route>
    <Route exact path={[routes.categories]}>
      <Services />
    </Route>
    <Route exact path={[routes.embed]}>
      <Embed />
    </Route>
    <AbsoluteRedirect to={`${process.env.NOT_FOUND}`} />
  </Switch>
);

export { routes };
export default Routes;
